import { render, staticRenderFns } from "./MSALContactUser.vue?vue&type=template&id=6a95ddb2"
import script from "./MSALContactUser.vue?vue&type=script&lang=js"
export * from "./MSALContactUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports